function create(BaseMap) {
  return class extends BaseMap {
    constructor(a, b) {
      let factory, values
      if (typeof a === 'function') {
        factory = a
      } else {
        values = a
        factory = b
      }
      super(values)
      Object.defineProperty(this, 'factory', { value: factory })
    }

    get(key) {
      if (this.has(key)) {
        return super.get(key)
      }
      const value = this.factory(key)
      this.set(key, value)
      return value
    }
  }
}

export const DefaultWeakMap = create(WeakMap)
export const DefaultMap = create(Map)
export default DefaultMap
